(ns dre.widgets.publication-type.events
  (:require
   [dre.fx :as dre.fx]
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.utils :as i18n-utils]
   [dre.network :as-alias network]
   [dre.pages.search.events :as search-events]
   [dre.utils :refer [filter-map tag-name]]
   [dre.shared.interface.names :refer [pubmed-pubtype curated-tag-labels]]
   [dre.widgets.analysis.tag-distribution :as tag-distribution-events]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

;; extension of analysis/tag_distribution

(def id
  :publication-type)

(defn ->pill
  [term]
  (let [label (or (get curated-tag-labels (str/lower-case (name term)))
                  (if (and (= (namespace term) "predicted") (= "D016449" (str/upper-case (name term))))
                    (get pubmed-pubtype (str/upper-case (str "PREDICTED-" (name term))))
                    (get pubmed-pubtype (str/upper-case (name term)))))]
    {:pill/type :tag
     :pill/query (tag-name term)
     :pill/display-label label
     :pill/label (if (and label (= (namespace term) "pubtype"))
                   (str "PubMed " label) label)}))

(defn prepare-data
  [data filters key filter-key]
  (let [data (filter-map data #(= (namespace %) key))
        f (get filters filter-key)
        click (fn [filter-key term]
                #(rf/dispatch [::search-events/widget-filter-select
                               filter-key (->pill term)]))]
    (map (fn [[term count]]
           (let [pill (->pill term)
                 f? (contains? f pill)
                 label (:pill/label pill)]
             (hash-map
              :label label
              :display-label (:pill/display-label pill)
              :term term
              :class [(when (seq f) (if f? "active" "inactive"))]
              :on-click (click filter-key term)
              :count count)))
         data)))

;; -- Events

(rf/reg-event-fx
 ::export
 [rf/trim-v]
 (fn-traced
  [{root-db :db} _]
  (let [db (get-in root-db tag-distribution-events/db-path)
        i18n-db (:i18n root-db)
        data (get-in db [:data id])
        predicted (prepare-data data [] "predicted" :publication-type)
        predicted (sort-by :count > predicted)
        curated (prepare-data data [] "curated" :publication-type)
        curated (sort-by :count > curated)
        pubtype (prepare-data data [] "pubtype" :publication-type)
        pubtype (sort-by :count > pubtype)
        header (i18n-utils/translate i18n-db "Machine learning, count, PubMed, count, Dr.Evidence currated tags, count")
        predicted-rows (keep (fn [{:keys [:label :count]}]
                               (when label (str (pr-str label) "," count)))
                             predicted)
        pubtype-rows (keep (fn [{:keys [:label :count]}]
                             (when label (str ",," (pr-str label) "," count)))
                           pubtype)
        curated-rows (keep (fn [{:keys [:label :count]}]
                             (when label (str ",,,," (pr-str label) "," count)))
                           curated)
        csv (str/join "\n" (cons header (concat predicted-rows pubtype-rows, curated-rows)))]
    (rf/dispatch [::dre.fx/download {:content csv
                                     :filename "publication-types.csv"
                                     :mimetype "text/csv"}])
    nil)))

;; -- Subscriptions
(rf/reg-sub
  ::state
  (fn [db _]
    (get-in db tag-distribution-events/db-path)))

(rf/reg-sub
 ::status
 :<- [::state]
 (fn [db _]
   (:state db)))

(rf/reg-sub
 ::data
 :<- [::state]
 :<- [::search-events/widget-filters]
 (fn [[db widget-filters] _]
   (let [data (get-in db [:data id])
         predicted (prepare-data data widget-filters "predicted" :publication-type)
         curated (prepare-data data widget-filters "curated" :publication-type)
         pubtype (prepare-data data widget-filters "pubtype" :publication-type)
         tbl (keep
              identity
              (concat
               [(when (seq predicted)
                  {:label [:span.separator [tr "Machine Learning"]]
                   :term "divider"
                   :asis true
                   :style {:font-weight "bold"}})]
               (reverse (sort-by :count predicted))
               [(when (seq curated)
                  {:label [:span.separator [tr "Dr.Evidence curated strings"]]
                   :term "divider"
                   :asis true
                   :style {:font-weight "bold"}})]
               (reverse (sort-by :count curated))
               [(when (seq pubtype)
                  {:label [:span.separator [tr "PubMed"]]
                   :term "divider"
                   :asis true
                   :style {:font-weight "bold"}})]
               (reverse (sort-by :count pubtype))))]
     (filter :label tbl))))

;; 
(defn- publication-type-pill?
  [{:pill/keys [type]}]
  (= type :tag))

(defn publication-type-filters
  [db]
  (->> db
       search-events/db-path
       :widget-filters
       id
       (filter publication-type-pill?)))

(defn publication-type-queries
  [db]
  (->> db
       search-events/db-path
       :search-query
       :query/pills
       (filter publication-type-pill?)))

(defn publication-type-source?
  [db]
  (let [x (concat (publication-type-filters db) (publication-type-queries db))]
    (not-empty x)))

(rf/reg-sub
 ::used-in-search?
 publication-type-source?)